module.exports = __webpack_public_path__ + "static/media/RubiconPhones.fbbe8776.png";